import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    programs: undefined,
    pagination: undefined,
    appointments: undefined,
    tasks: undefined,
    communications: {communityMessages: [],chatMessages: []},
    /** Mapa programId -> programName (objeto con display) rellenado al cargar /details; la tabla lo usa igual que la vista del paciente */
    programNameByProgramId: {},
}

export const programsSlide = createSlice({
    name: 'programs',
    initialState,
    reducers: {
        // Persistido en localStorage vía redux-persist -- sin esto, el siguiente login en el
        // mismo navegador hereda tareas/programas clínicos del usuario anterior hasta que algo
        // los sobreescriba (fuga real de dato clínico entre usuarios). Llamar SIEMPRE al cerrar sesión.
        resetPrograms: () => initialState,
        setProgramNameForProgramId: (state, action) => {
            const { programId, programName } = action.payload || {};
            if (programId != null && programName != null) {
                state.programNameByProgramId = state.programNameByProgramId || {};
                state.programNameByProgramId[programId] = programName;
            }
        },
        setPrograms: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.programs = action.payload
        },
        setPagination: (state, action) => {
            state.pagination = action.payload
        },
        setAppointments: (state, action) => {
            state.appointments = action.payload
        },
        setTasks: (state, action) => {
            state.tasks = action.payload
        },
        setCommunications: (state, action) => {
            state.communications = action.payload
        },
        // Fusiona solo los campos que llegan. setCommunications reemplaza el objeto entero y, como
        // varias partes (contenedor, chat, monitores) escribían copiando un objeto ya viejo, se
        // pisaban entre sí (badges que saltaban o se ponían a 0).
        patchCommunications: (state, action) => {
            state.communications = { ...(state.communications || {}), ...action.payload }
        },
    },
})

// Action creators are generated for each case reducer function
export const { setPrograms, setPagination, setAppointments, setTasks, setCommunications, patchCommunications, setProgramNameForProgramId, resetPrograms } = programsSlide.actions

export default programsSlide.reducer
